var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserIconOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon  - user"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3.75C9.10051 3.75 6.75 6.1005 6.75 9C6.75 11.8995 9.10051 14.25 12 14.25C14.8995 14.25 17.25 11.8995 17.25 9C17.25 6.1005 14.8995 3.75 12 3.75ZM5.25 9C5.25 5.27208 8.27208 2.25 12 2.25C15.7279 2.25 18.75 5.27208 18.75 9C18.75 12.7279 15.7279 15.75 12 15.75C8.27208 15.75 5.25 12.7279 5.25 9Z",
    fill: "#4A4C4F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 15.7492C10.2884 15.7492 8.60689 16.1998 7.12461 17.0557C5.64233 17.9115 4.41149 19.1426 3.55581 20.625C3.34873 20.9837 2.89005 21.1066 2.53131 20.8996C2.17257 20.6925 2.04963 20.2338 2.2567 19.8751C3.24402 18.1646 4.66423 16.7442 6.37455 15.7566C8.08488 14.7691 10.025 14.2492 12 14.2492C13.975 14.2492 15.9151 14.7691 17.6255 15.7566C19.3358 16.7442 20.756 18.1646 21.7433 19.8751C21.9504 20.2338 21.8274 20.6925 21.4687 20.8996C21.11 21.1066 20.6513 20.9837 20.4442 20.625C19.5885 19.1426 18.3577 17.9115 16.8754 17.0557C15.3931 16.1998 13.7116 15.7492 12 15.7492Z",
    fill: "#4A4C4F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIconOutline);
export default __webpack_public_path__ + "static/media/user-icon-outline.e760b270a39a6b664f552573800b3a1d.svg";
export { ForwardRef as ReactComponent };